import { useAuth } from '../context/AuthContext.js';
import { useSnap } from '../hooks/useSnap.js';
import { PlugIcon } from './Icons.js';

interface InstallSnapButtonProps {
  variant?: 'primary' | 'secondary' | 'compact';
  className?: string;
}

export function InstallSnapButton({ variant = 'primary', className = '' }: InstallSnapButtonProps) {
  const { token } = useAuth();
  const snap = useSnap(token);

  // Already installed — show confirmation
  if (snap.isInstalled) {
    return (
      <span className={`isb-installed ${className}`}>
        <PlugIcon className="isb-icon" aria-hidden="true" />
        Snap Installed
      </span>
    );
  }

  // No MetaMask — link to download
  if (!snap.isMetaMask) {
    return (
      <a
        href="https://metamask.io"
        target="_blank"
        rel="noopener noreferrer"
        className={`btn ${variant === 'secondary' ? 'btn-secondary' : 'btn-primary'} isb-btn ${className}`}
      >
        <PlugIcon className="isb-icon" aria-hidden="true" />
        Get MetaMask
      </a>
    );
  }

  // Snap config unavailable - show a friendly message instead of a broken button
  if (snap.error && snap.error.includes("not configured")) {
    return (
      <div className={`isb-config-unavailable ${className}`} role="alert">
        <PlugIcon className="isb-icon" aria-hidden="true" />
        <span>Snap configuration is temporarily unavailable. Please try again later.</span>
      </div>
    );
  }

  // MetaMask available, snap not installed
  return (
    <button
      className={`btn ${variant === 'secondary' ? 'btn-secondary' : 'btn-primary'} ${variant === 'compact' ? 'btn-sm' : ''} isb-btn ${className}`}
      onClick={snap.installSnap}
      disabled={snap.isLoading}
    >
      <PlugIcon className="isb-icon" aria-hidden="true" />
      {snap.isLoading ? 'Installing...' : 'Install Snap \u2014 Free Protection'}
    </button>
  );
}
